import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { GetGame, GetDeveloperInfo, GetTagInfo } from "../../Utilities";
import Popup from './Popup.js'
import { IsValid } from '../../Utilities.js';
import '../../styles/Game.css';

 const GameCard = ({ gameId, gameInfo, handleClickOverride }) => {
    const [gameData, setGameData] = useState(null);
    const [developerInfo, setDeveloperInfo] = useState(null)
    const [error, setError] = useState(null);
    const [gamePhoto, setGamePhoto] = useState("");
    const [gameDesc, setGameDesc] = useState("");
    const [seeMore, setSeeMore] = useState();
    const [steamLink, setSteamLink] = useState();
    const [epicLink, setEpicLink] = useState();
    const [publicBuilds, setPublicBuilds] = useState([]);
    const [gameName, setGameName] = useState();
    const [devName, setDevName] = useState();
    // NEW HERE FOR POPUP
    const [showPopup, setShowPopup] = useState(false);
    const [tagData, setTagData] = useState([]);
    const [tags, setTags] = useState([]);

     useEffect(() => {
        const fetchGameAndDeveloper = async () => {
            try {
                var game;
                if (IsValid(gameId) === true) {
                    game = await GetGame(gameId);
                    if (!game) {
                        throw new Error('Game not found');
                    }
                    setGameData(game.message);
                    //console.log(game.message);
                }
                else {
                    game = { message: gameInfo };
                    setGameData(gameInfo);
                }

                const developer = await GetDeveloperInfo(game.message.DeveloperID);
                if (!developer) {
                    throw new Error('Developer not found');
                }
                setDeveloperInfo(developer.message);

                //console.log("WOWWWWW", game.message.TagId);
                const tagNames = await GetTagInfo(game.message.TagId);

                setTagData(tagNames);

            } catch (err) {
                setError(err.message);
            }
        };

        const req = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: ""
        }

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetTagInfo', req)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    data.message.sort((a, b) => {
                        if (parseInt(a.id) < parseInt(b.id)) {
                            return -1;
                        }
                        if (parseInt(a.id) > parseInt(b.id)) {
                            return 1;
                        }
                        return 0;
                    });
                    setTags(data.message);
                }
            });

        fetchGameAndDeveloper();
    }, [gameId, gameInfo]);

     useEffect(() => {
         if (gameData === undefined || gameData === null || developerInfo === undefined || developerInfo === null) return;
         const { Name, TagId = [], Description, PhotoUrl, SteamLink, EpicLink, PublicBuildLinks } = gameData;
         const { DevName } = developerInfo;

         setGameName(Name);
         setDevName(DevName);
         setSteamLink(SteamLink);
         setEpicLink(EpicLink);
         setPublicBuilds(PublicBuildLinks);

         setGamePhoto(`${process.env.REACT_APP_S3_BASE_URL}${PhotoUrl}`);
         const maxLength = 70;
         setGameDesc(IsValid(Description) === false ? "" : (Description.length > maxLength
                 ? Description.substring(0, maxLength - 10) + "... " //can update this logic to cut to the last word instead of characters
             : Description));

         setSeeMore( IsValid(Description) === false ? "" : (Description.length > maxLength ? (
             <span className="see-more">See More</span>
         ) : null));
     }, [gameData, developerInfo])


     useEffect(() => {
        GetTagInfo(gameInfo.TagId)
            .then((data) => {
                setTagData(data);
            });
    }, [gameInfo]);

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!gameData || !developerInfo) {
    return <div>Loading...</div>;
  }

  const handleClick = () => {
    setShowPopup(!showPopup);
  }

  return (
    <div>
        {
          showPopup && (
                  <Popup handleClick={handleClick} gameData={gameData} tagData={tagData} developerInfo={developerInfo} />
          )
        }
        <div className="game-card" onClick={handleClick} style={{ cursor: 'pointer', width:"100%", height:"100%" }}>
        <div className="game-card-image">
          <img src={gamePhoto} alt="Game cover" />
        </div>
        <div className="game-card-title">
          <text>{gameName}</text>
        </div>
              <div className='game-card-content'>
                <div className='game-card-dev-info'>
                    <div className='game-card-studio-div'>
                        <p className="game-card-studio">Studio:</p>
                        <p className="game-card-studio-name">{gameData.DeveloperNameOverride || devName}</p>
                    </div>
                    {gameData.PublisherName !== undefined && gameData.PublisherName !== "" && gameData.PublisherName !== null && <div className='game-card-publisher-div'>
                        <p className="game-card-publisher">Publisher:</p>
                          <p className="game-card-publisher-name">{gameData.PublisherName}</p>
                    </div>}
                </div>
          <div className="game-card-tags">
            {IsValid(gameInfo.TagId) === true && gameInfo.TagId.split(',').map((tag, index) => (
              <span className="game-card-tag">{tags[tag].TagName}</span>
            ))}
          </div>
          <p className="game-card-description">
            {gameDesc}{seeMore && <>{seeMore}</>}
          </p>
          <div className="game-card-platforms">
            {steamLink && (
                          <a href={steamLink} target="_blank" rel="noopener noreferrer">
                <img
                  src={'/steamIcon.png'}
                  alt="Steam"
                  className="platform-logo"
                />
              </a>
            )}
            {epicLink && (
              <a href={epicLink} target="_blank" rel="noopener noreferrer">
                <img
                  src={'epicIcon.png'}
                  alt="Epic Games"
                  className="platform-logo"
                />
              </a>
            )}
            {publicBuilds && (
              <a href={'/GameDownloads?gameId='+gameInfo.ID} target="_blank" rel="noopener noreferrer">
                <img
                  src={'/DownloadIcon.png'}
                  alt="Download Icon"
                  className="platform-logo"
                />
              </a>
            )}
          </div>
          </div>
      </div>
    </div>
  );
};

export function GameTile({ gameId }) {
    const navigate = useNavigate();
    const { page, id, subpage, subid } = useParams();
    const [gameInfo, setGameInfo] = useState();
    const [photoUrl, setPhotoUrl] = useState();
    const [gameName, setGameName] = useState();

    useEffect(() => {
        GetGameInfo();
    }, [gameId]);

    useEffect(() => {
        console.log("gameInfo Updated");
        if (gameInfo !== undefined) {
            var { Name, TagId = [], Description, PhotoUrl, SteamLink, EpicLink, PublicBuildLinks } = gameInfo;

            setPhotoUrl(`${process.env.REACT_APP_S3_BASE_URL}${PhotoUrl}`);
            setGameName(Name);
        }
    }, [gameInfo])

    function GetGameInfo() {
        var URL = process.env.REACT_APP_NODE_ADDRESS + "/GetGameInfo";

        const reqOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'gameId': gameId })
        };

        fetch(URL, reqOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    if (IsValid(data.message.PublicBuildLinks) === true) {
                        data.message.PublicBuildLinks = JSON.parse(data.message.PublicBuildLinks);
                    }

                    if (IsValid(data.message.PrivateBuildLinks) === true) {
                        data.message.PrivateBuildLinks = JSON.parse(data.message.PrivateBuildLinks);
                    }
                    setGameInfo(data.message);
                }
            });
    }

    function handleClick() {
        console.log("Click called");
        navigate("/account/developer/" + id + "/game/" + gameId);
    }


    return (
        <div style={{ width: "200px", height: "200px", margin: "20px" }}>
            <div className="game-tile-card" onClick={handleClick} style={{ cursor: 'pointer', width: "100%", height: "100%" }}>
                <div className="game-card-image">
                    <img src={photoUrl} alt="Game cover" />
                </div>
                <div className="game-card-title">
                    <text>{gameName}</text>
                </div>
            </div>
        </div>
    );
}

export function NewGameTile() {
    const navigate = useNavigate();
    const { page, id, subpage, subid } = useParams();

    function handleClick() {
        console.log("Click called");
        navigate("/account/developer/" + id + "/newGame");
    }


    return (
        <div style={{ width: "200px", height: "200px", margin: "20px" }}>
            <div className="game-tile-card" onClick={handleClick} style={{ cursor: 'pointer', width: "100%", height: "100%" }}>
                <div className="game-card-image">
                    <p style={{ width:"100%", height:"70%", fontSize:"120px", margin:"auto", textAlign:"center", color:"#FFCF00"}}>+</p>
                </div>
                <div className="game-card-title">
                    <text>Add New Game</text>
                </div>
            </div>
        </div>
    );
}

export default GameCard;

